<template>
  <div>
    <el-tabs type="card">
      <!-- 绿夹克讲坛 -->
      <el-tab-pane :label="$t('mainPage.greenJacketForum')">
        <el-row>
          <el-col :span="24">
            <el-table style="width:100%" :data="data">
              <!-- 上课日期 -->
              <el-table-column
                label="上课日期"
                prop="dateAndTime"
                align="center"
                :formatter="timeFormat"
                width="135px"
              ></el-table-column>
              <!-- 课程编号 -->
              <el-table-column
                :label="$t('courseOption.courseNumber')"
                align="center"
                width="135px"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.field +
                      scope.row.category +
                      scope.row.courseNumber
                  }}
                </template>
              </el-table-column>
              <!-- 课程名称 -->
              <el-table-column
                :label="$t('courseOption.courseName')"
                prop="courseName"
                align="left"
                min-width="20"
              ></el-table-column>
              <!-- 考试成绩 -->
              <el-table-column
                :label="$t('p0214.examScores')"
                prop="examScore"
                align="center"
                width="85px"
              ></el-table-column>
              <!-- 证书 -->
              <el-table-column
                :label="$t('courseOption.certificate')"
                prop="category"
                align="center"
                min-width="20"
                ><template slot-scope="scope">
                  <div
                    v-for="(item, index) in scope.row.definitionNameList"
                    :key="index"
                  >
                    <div
                      v-if="
                        scope.row.classStatus == 1
                          ? true
                          : scope.row.certificateStateList[index] == '3'
                          ? true
                          : false
                      "
                    >
                      <el-button
                        @click="viewTheCertificate(scope, item)"
                        style="white-space: pre-wrap;word-break: break-all;"
                        type="text"
                        >{{ item }}</el-button
                      ><br />
                    </div>
                  </div> </template
              ></el-table-column>
            </el-table>
            <!-- 返回 -->
            <el-button
              style="margin-top:55px"
              type="return"
              @click="goBack()"
              >{{ $t("common.back") }}</el-button
            >
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "TQSManagementP0214",

  data() {
    let p0212 = JSON.parse(sessionStorage.getItem("p0212"));
    return {
      p0212: p0212,
      data: [],
      currentPage: JSON.parse(sessionStorage.getItem("p0212")).currentPage
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    // 返回按钮
    goBack() {
      //返回按钮标示
      sessionStorage.setItem("detail", true);
      sessionStorage.setItem("currentPage", this.currentPage);
      //返回按钮标示
      this.$router.go(-1);
    },
    // 初始化
    init() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/greenJacketPulpit";
      console.log(
        "🚀 ~ file: P0214.vue:101 ~ init ~ this.p0212.userID",
        this.p0212.userID
      );

      this.$http
        .post(url, {
          userID: this.p0212.userID
        })
        .then(response => {
          if (response.data.code === 200) {
            this.data = response.data.data;
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 查看证书
    viewTheCertificate(scope, item) {
      let row = scope.row;
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/downloadTheCertificate";
      this.$http
        .post(
          url,
          {
            field: row.field,
            category: row.category,
            courseNumber: row.courseNumber,
            filePath: row.filePath,
            userID: row.userID,
            passNo: row.passNo,
            definitionName: item,
            courseName: row.courseName
          },
          { responseType: "blob" }
        )
        .then(response => {
          // console.log("文件下载成功", response.data);

          const blob = new Blob([response.data]);
          console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            console.log("文件大小为0");
            loading.close();
          } else {
            // const fileName = "证书.pdf";
            let fileName = item + ".pdf";
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
          }
          loading.close();
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 日期格式胡
    timeFormat(row) {
      return moment(row.dateAndTime).format("YYYY-MM-DD");
    }
  }
};
</script>

<style lang="scss" scoped>
// 表格样式
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
  padding: 8.5px 0;
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0214.vue